import ContentLoader, { Rect } from "react-content-loader/native";
import { Card, Divider, HStack, VStack, View } from "@gluestack-ui/themed";

const SKELETON_BG = "#E4E4E7";
const SKELETON_FG = "#F4F4F5";

interface SkeletonBlockProps {
  height: number | string;
  width?: number | string;
  borderRadius?: number;
}

const SkeletonBlock = ({
  height,
  width = "100%",
  borderRadius = 8
}: SkeletonBlockProps) => (
  <VStack h={height} w={width}>
    <ContentLoader
      backgroundColor={SKELETON_BG}
      foregroundColor={SKELETON_FG}
      speed={1}
      width="100%"
      height="100%"
    >
      <Rect
        x="0"
        y="0"
        rx={borderRadius}
        ry={borderRadius}
        width="100%"
        height="100%"
      />
    </ContentLoader>
  </VStack>
);

const ProposalItemSkeleton = () => (
  <VStack alignItems="flex-start" w="$full">
    <HStack w="$full" alignItems="center" justifyContent="space-between">
      <SkeletonBlock height={24} width="58%" borderRadius={6} />
      <SkeletonBlock height={16} width={16} borderRadius={8} />
    </HStack>
    <HStack mt="$4" alignItems="center" w="$full" gap="$2">
      <SkeletonBlock height={24} width={72} borderRadius={4} />
      <SkeletonBlock height={16} width="62%" borderRadius={4} />
    </HStack>
    <HStack alignItems="center" mt="$2" w="$full">
      <SkeletonBlock height={12} width="48%" borderRadius={4} />
    </HStack>
  </VStack>
);

const ProposalGroupSkeleton = ({ itemCount = 2 }: { itemCount?: number }) => (
  <View gap="$4" mb="$6" w="$full">
    <SkeletonBlock height={14} width="55%" borderRadius={4} />
    <Card w="$full" p="$4">
      {Array.from({ length: itemCount }).map((_, index) => (
        <View key={index} w="$full">
          <ProposalItemSkeleton />
          {index < itemCount - 1 ? <Divider my="$4" /> : null}
        </View>
      ))}
    </Card>
  </View>
);

export const ProposalsSearchLoading = () => {
  return (
    <VStack w="$full" gap="$2">
      <ProposalGroupSkeleton itemCount={2} />
      <ProposalGroupSkeleton itemCount={1} />
    </VStack>
  );
};
